export const Unit = {
	HOUR: 'h',
	PERCENTAGE: '%',
	DAY: 'day',
};
